export enum Status {
    ACTIF = 'ACTIF',
    CLOS = 'CLOS',
    RESILIE = 'RESILIE',
    INPROGRESS = 'EN CREATION',
}
